export function getRole(userId: string): string {
    const role = localStorage.getItem("role-" + String(userId));
    if (role === null) {
        return "";
    }
    return role;
}

export function setRole(userId: string, role: string): void {
    localStorage.setItem("role-" + String(userId), role);
}

export function delRole(userId: string): void {
    localStorage.removeItem("role-" + String(userId));
}